import { makeHttpRequest } from "@/shared";

import { mapCalculatedRepairFromServer } from "./mappers/mapCalculatedRepairFromServer";
import { mapRepairServiceToServer } from "./mappers/mapRepairServiceToServer.js";
export const addRepairService = async (sessionKey, service) => {
    const response = (
        await makeHttpRequest({
            url: `/repair/builder/${sessionKey}/add/service`,
            method: "PUT",
            data: mapRepairServiceToServer(service),
        })
    ).data;

    return mapCalculatedRepairFromServer(response.data);
};
